var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { createAsyncThunk, createSlice, } from '@reduxjs/toolkit';
import { queryParams } from '../code-studio/utils';
import { fetchSignedCookies } from '../utils';
import { getSongManifest, getSelectedSong, parseSongOptions, loadSong, unloadSong, loadSongMetadata, } from './songs';
var initialState = {
    selectedSong: 'macklemore90',
    songData: {},
    runIsStarting: false,
    currentAiModalField: undefined,
    isRunning: false,
    currentSongMetadata: undefined,
};
// THUNKS
/** Loads the song manifest and initial song. */
export var initSongs = createAsyncThunk('dance/initSongs', function (payload, _a) {
    var dispatch = _a.dispatch;
    return __awaiter(void 0, void 0, void 0, function () {
        var useRestrictedSongs, onAuthError, selectSongOptions, onSongSelected, userManifest, songManifest, songData, selectedSong;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    useRestrictedSongs = payload.useRestrictedSongs, onAuthError = payload.onAuthError, selectSongOptions = payload.selectSongOptions, onSongSelected = payload.onSongSelected;
                    userManifest = queryParams('manifest');
                    return [4 /*yield*/, getSongManifest(useRestrictedSongs, userManifest)];
                case 1:
                    songManifest = _b.sent();
                    songData = parseSongOptions(songManifest);
                    selectedSong = getSelectedSong(songManifest, selectSongOptions);
                    // Set selectedSong first, so we don't initially show the wrong song.
                    dispatch(setSelectedSong(selectedSong));
                    dispatch(setSongData(songData));
                    loadSong(selectedSong, songData, function (status) {
                        if (status === 403) {
                            // Something is wrong, because we just fetched cloudfront credentials.
                            onAuthError(selectedSong);
                        }
                    });
                    return [4 /*yield*/, handleSongSelection(dispatch, selectedSong, onSongSelected)];
                case 2:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
});
/** Called when a new song is selected. Unloads the previous song and loads the new song. */
export var setSong = createAsyncThunk('dance/setSong', function (payload, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var songId, onAuthError, onSongSelected, state, _b, lastSongId, songData;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    songId = payload.songId, onAuthError = payload.onAuthError, onSongSelected = payload.onSongSelected;
                    state = getState();
                    _b = state.dance, lastSongId = _b.selectedSong, songData = _b.songData;
                    if (songId === lastSongId) {
                        return [2 /*return*/];
                    }
                    dispatch(setSelectedSong(songId));
                    unloadSong(lastSongId, songData);
                    loadSong(songId, songData, function (status) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(status === 403)) return [3 /*break*/, 2];
                                    // The cloudfront signed cookies may have expired.
                                    return [4 /*yield*/, fetchSignedCookies()];
                                case 1:
                                    // The cloudfront signed cookies may have expired.
                                    _a.sent();
                                    loadSong(songId, songData, function (status) {
                                        if (status === 403) {
                                            // Something is wrong, because we just re-fetched cloudfront credentials.
                                            onAuthError(songId);
                                        }
                                    });
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, handleSongSelection(dispatch, songId, onSongSelected)];
                case 1:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
});
function handleSongSelection(dispatch, songId, onSongSelected) {
    return __awaiter(this, void 0, void 0, function () {
        var metadata;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onSongSelected) return [3 /*break*/, 1];
                    onSongSelected(songId);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, loadSongMetadata(songId)];
                case 2:
                    metadata = _a.sent();
                    dispatch(setCurrentSongMetadata(metadata));
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
var danceSlice = createSlice({
    name: 'dance',
    initialState: initialState,
    reducers: {
        setSongData: function (state, action) {
            state.songData = action.payload;
        },
        setSelectedSong: function (state, action) {
            state.selectedSong = action.payload;
        },
        setRunIsStarting: function (state, action) {
            state.runIsStarting = action.payload;
        },
        setCurrentSongMetadata: function (state, action) {
            state.currentSongMetadata = action.payload;
        },
        setCurrentAiModalField: function (state, action) {
            state.currentAiModalField = action.payload;
        },
    },
});
export var setSongData = (_a = danceSlice.actions, _a.setSongData), setSelectedSong = _a.setSelectedSong, setRunIsStarting = _a.setRunIsStarting, setCurrentSongMetadata = _a.setCurrentSongMetadata, setCurrentAiModalField = _a.setCurrentAiModalField;
export var reducers = { dance: danceSlice.reducer };
